export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  primary: '#3D2A70',
  accent: '#A45785', 
  purpleLight: '#BFBED7',
  errorRed: '#ef4444', // Bright red that works on both light and dark backgrounds
  buttonColor: '#9282CB',
  primaryLightTransparent: '#BFBED733', 
  lightBlue: '#add8e6',
  darkPurple: '#371652',
  yellowAccent: '#f4c430',
  
  backgroundLight: '#ffffff',
  backgroundGrey: 'rgb(226, 223, 231)',
  
  textDark: '#333333',
  textLight: '#ffffff',
  textPlaceholder: '#999', 
  textMuted: '#666666',

  inputBorder: '#D0D0D0', 
  inputErrorBorder: 'red', 

  overlayBackground: 'rgba(0, 0, 0, 0.5)',
};

export default COLORS;